import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { WalletContextProvider } from "./contexts/WalletContext";
import { AuthProvider } from "./contexts/AuthContext";
import PulsePage from "./pages/PulsePage";
import TokenPage from "./pages/TokenPage";
import AuthCallback from "./pages/AuthCallback";
import LogsViewer from "./pages/LogsViewer";

const App = () => {
  return (
    <AuthProvider>
    <WalletContextProvider>
      <Router>
        <Routes>
            {/* Auth callback route for Magic Link redirects */}
            <Route path="/auth/callback" element={<AuthCallback />} />
          {/* Pulse page is full-screen (no sidebar) */}
          <Route path="/" element={<PulsePage />} />
          <Route path="/pulse" element={<PulsePage />} />
          {/* Token detail page is full-screen (no MainLayout sidebar) */}
          <Route
            path="/:chainId/:tokenAddress"
            element={<TokenPage />}
          />
            {/* Logs viewer for debugging */}
            <Route path="/logs" element={<LogsViewer />} />
        </Routes>
      </Router>
    </WalletContextProvider>
    </AuthProvider>
  );
};

export default App;
